import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserDataService } from 'src/app/services/user-data/user-data.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(
    private router: Router,
    private userData: UserDataService
  ) { }
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.canAccessPage(state.url);
  }
  
  async canAccessPage(currentUrl): Promise<boolean | UrlTree> {

    var isGatewayUrlConfigured = await this.userData.isGatewayConfigured();
    var hasLoggedIn = await this.userData.hasLoggedIn();

    if (isGatewayUrlConfigured && hasLoggedIn) {
      return true;
    }
    else {
      this.userData.setUrlToRedirect(currentUrl);
      return this.router.parseUrl('/login');
    }
    
  }

}
